"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringEmptyOnly = exports.stringNotEmptyOnly = exports.ensureStringOnly = void 0;
// HMMM: what if 'string' is an object?
const ensureStringOnly = (string) => (
// eslint-disable-next-line eqeqeq
(string != undefined) ? `${string}` : '');
exports.ensureStringOnly = ensureStringOnly;
const stringNotEmptyOnly = (stringable) => {
    const string = (0, exports.ensureStringOnly)(stringable);
    return ((string.length > 0) && !['null', 'undefined'].includes(string));
};
exports.stringNotEmptyOnly = stringNotEmptyOnly;
const stringEmptyOnly = (stringable) => (!(0, exports.stringNotEmptyOnly)(stringable));
exports.stringEmptyOnly = stringEmptyOnly;
//# sourceMappingURL=display.js.map